export enum GateType {
  Webinar = "Webinar",
  All = "All"
}
